"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 52.92 24",
    width: "52.92",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m51.22 17.41h-2.69c-.13-.12-.26-.24-.4-.35a8.21 8.21 0 0 0 -3.42-15.67h-3.83v-.64a.76.76 0 0 0 -.75-.75h-4.31a.77.77 0 0 0 -.75.75v.64h-18.3v-.64a.76.76 0 0 0 -.77-.75h-4.29a.75.75 0 0 0 -.71.75v.64h-2.79a8.21 8.21 0 0 0 -3.42 15.67 3.34 3.34 0 0 0 -.4.35h-2.58a.78.78 0 0 0 -.78.78h-.03a.76.76 0 0 0 .75.75h1.75a3.49 3.49 0 0 0 -.18 1.11 3.91 3.91 0 1 0 7.08-2.28h1.6a3.82 3.82 0 0 0 -.75 2.28 3.91 3.91 0 0 0 7.75.7h15a3.91 3.91 0 1 0 7-3h1.58a3.91 3.91 0 0 0 6.34 4.58 4 4 0 0 0 .74-2.3 3.83 3.83 0 0 0 -.24-1.03h1.83a.76.76 0 0 0 .75-.75.79.79 0 0 0 -.72-.84zm-6 .38.55-.05a2.35 2.35 0 1 1 -.55.05zm-29.48 0a2.36 2.36 0 1 1 -1.15 0zm22.63 0a2.36 2.36 0 1 1 -1.15 0zm-30.63 0a2.36 2.36 0 1 1 -.55-.05z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m20.98 4.12h10.96v10.96h-10.96z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m22.81 15.08v-10.96l9.13 5.48z"
  })));
};

exports["default"] = _default;